require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-myoffers-testmode.json") })
        }
      }, "path---es-myoffers-testmode");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-myoffers-testmode!./.cache/json/es-myoffers-testmode.json
// module id = 2591
// module chunks = 231608221292675